import { FetchCompanyEventTemplatesSortTypes } from './companyEventTemplatesTypes';

export const INITIAL_COMPANY_EVENT_TEMPLATES_FILTERS = {};
export const INITIAL_COMPANY_EVENT_TEMPLATES_LIMIT = 20;
export const INITIAL_COMPANY_EVENT_TEMPLATES_PAGE = 1;
export const INITIAL_COMPANY_EVENT_TEMPLATES_SORT = [
  FetchCompanyEventTemplatesSortTypes.CREATED_AT_DESC
];
